import React, { useState } from "react";
import http from "../services/httpService";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

import { editProspectPath, editInvestPath } from "../utils/varialbles";
import { Button, Grid, SvgIcon } from "@material-ui/core";
import { useLocation, useHistory } from "react-router-dom";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import {
  Select,
  MenuItem,
  TextField,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Radio,
} from "@material-ui/core";

function ProspectTask() {
  const location = useLocation();
  const myparam = location.state;
  let history = useHistory();

  const columns = [
    { type: "select", label: "Task Type" },
    { type: "date", label: "Date" },
    { type: "text", label: "Comments" },
  ];

  const [setTasktype, showTasktype] = useState({
    tasktype: "",
    taskdate: "",
    tasktime: "",
    taskcomments: "",
  });

  const { tasktype, taskdate, taskcomments, tasktime } = setTasktype;

  const handleChange = (e) => {
    showTasktype({ ...setTasktype, [e.target.name]: e.target.value });
  };

  var cust_id;
  if (myparam.cust__id) {
    cust_id = myparam.cust__id;
  } else if (myparam.customer_id) {
    cust_id = myparam.customer_id;
  }

  const emp_id = localStorage.getItem("employee_id");

  const newTask = {
    tasktype: tasktype,
    date: tasktime,
    commments: taskcomments,
    cust: cust_id,
    emp: emp_id,
  };

  const add = () => {
    // let cust_id= myparam.cust__id || myparam.customer_id
    http
      .post(`/task`, newTask)
      .then((res) => {
        if (myparam && myparam.cust__id) {
          history.push({
            pathname: editProspectPath,
            state: myparam,
          });
        }

        if (myparam && myparam.customer_id) {
          history.push({
            pathname: editInvestPath,
            state: myparam,
          });
        }
      })
      .catch((err) => {
        // (err);
      });
  };

  // useEffect((e) => {

  // },[]);

  // const goBack= (e)=>{
  //   e.preventDefault();
  //   if (myparam && myparam.cust__id) {
  //     history.push({
  //         "pathname": editProspectPath, state: myparam
  //     });
  // }
  //   }
  // }

  const goBack = (e) => {
    e.preventDefault();
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: editProspectPath,
        state: myparam,
      });
    }

    if (myparam && myparam.customer_id) {
      history.push({
        pathname: editInvestPath,
        state: myparam,
      });
    }
  };
  const newDate = new Date();

  const format =
    newDate.getFullYear() +
    "-" +
    (newDate.getMonth() + 1 >= 10
      ? newDate.getMonth() + 1
      : "0" + (newDate.getMonth() + 1)) +
    "-" +
    (newDate.getDate() >= 10 ? newDate.getDate() : "0" + newDate.getDate()) +
    "T" +
    (newDate.getHours() >= 10 ? newDate.getHours() : "0" + newDate.getHours()) +
    ":" +
    (newDate.getMinutes() >= 10
      ? newDate.getMinutes()
      : "0" + newDate.getMinutes());
  const currentDate = format.toString();
  const handleChange2 = (e) => {
    showTasktype({
      ...setTasktype,
      tasktime:
        e.$y +
        "-" +
        (e.$M + 1 >= 10 ? e.$M + 1 : "0" + (e.$M + 1)) +
        "-" +
        (e.$D >= 10 ? e.$D : "0" + e.$D) +
        "T" +
        (e.$H >= 10 ? e.$H : "0" + e.$H) +
        ":" +
        (e.$m >= 10 ? e.$m : "0" + e.$m),
    });
  };

  return (
    <div>
      {/* <button>Overview</button> */}
      <div style={{ display: "flex" }}>
        <Button
          variant="outlined"
          color="default"
          startIcon={<ArrowBackIosIcon />}
          style={{ height: "40px" }}
          onClick={goBack}
        >
          Back
        </Button>
        <h1
          style={{ textAlign: "center", color: "#08054e", marginLeft: "90px" }}
        >
          Add Task
        </h1>
      </div>
      <div>
        {/* {columns.map(column => {column.label} <spn>*</spn>
      {column.type === 'select' ? <select></select> :  column.type === 'date' ? <input type="date"/> : column.type === 'text' ? <input type="text"/> : null}    
      )} */}

        {columns.map((item) => (
          <div style={{ display: "flex", margin: "40px 0px" }}>
            <label style={{ width: "10%", fontSize: "20px" }}>
              {item.label}
              <span style={{ color: "red" }}>*</span>
            </label>
            {item.type === "select" ? (
              <select
                name="tasktype"
                // value={tasktype}
                onChange={handleChange}
                style={{ width: 200, height: 40, borderRadius: 5 }}
              >
                <option value="">Select</option>
                <option value="1">Follow Up Call</option>
                <option value="2">Follow Up Mail</option>
                <option value="3">Follow Up Message</option>
                <option value="4">Call Back</option>
              </select>
            ) : item.type === "date" ? (
              <>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    renderInput={(params) => <TextField {...params} />}
                    placeholder="Select date and time"
                    name={tasktime}
                    value={tasktime}
                    // onChange={(newValue) => {
                    //     // setValue(newValue);
                    //     setValue(newValue.$y+"-"+(((newValue.$M)+1) >=10 ? ((newValue.$M)+1) : "0"+ ((newValue.$M)+1))+"-"+(newValue.$D >=10 ? newValue.$D : "0" + newValue.$D)+"T"+(newValue.$H >=10 ? newValue.$H : "0" + newValue.$H)+":"+(newValue.$m >=10 ? newValue.$m : "0" + newValue.$m));
                    // }}
                    onChange={handleChange2}
                    minDateTime={dayjs(currentDate)}
                  // className="placeholder"
                  />
                </LocalizationProvider>
                {/* <input
                  type="datetime-local"
                  onChange={handleChange}
                  name="taskdate"
                  style={{
                    width: 200,
                    display: "block",
                    height: 40,
                    borderRadius: 5,
                    border: "1px solid #000",
                  }}
                /> */}
                {/* <input type="time" onChange={handleChange} name="tasktime" style={{width:200}}/>  */}
              </>
            ) : item.type === "text" ? (
              <textarea
                col="3"
                name="taskcomments"
                onChange={handleChange}
                style={{ width: 200, height: 40, borderRadius: 5, outline: 0 }}
              ></textarea>
            ) : null}
          </div>
        ))}
      </div>

      <button
        onClick={add}
        style={{
          width: 150,
          height: 50,
          backgroundColor: "#2835d5",
          color: "#fff",
          borderRadius: "5px",
          fontSize: 16,
          border: "0px solid transparent",
          cursor: "pointer",
        }}
      >
        Add
      </button>
    </div>
  );
}

export default ProspectTask;
